module.exports = __webpack_public_path__ + "img/logo.12534516.12534516.png";